/* NDIS self-managed invoice request in Shopify cart / cart drawer. */
(function(){
"use strict";
var busy=false,latestState=null;
function controls(){return Array.from(document.querySelectorAll("[data-ndis-cart-request]"))}
function setAll(yes,message,problem){
 controls().forEach(function(root){
  var input=root.querySelector("[data-ndis-cart-checkbox]");
  if(input){input.checked=!!yes;input.disabled=busy}
  var text=root.querySelector("[data-ndis-cart-status]");
  if(text){
   text.hidden=!message;text.textContent=message||"";
   text.classList.toggle("is-error",!!problem);text.classList.toggle("is-success",!!message&&!problem)
  }
 })
}
function api(path,options){
 var base=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||"/";
 return fetch(base+path,Object.assign({credentials:"same-origin",headers:{"Accept":"application/json"}},options||{}))
 .then(function(r){if(!r.ok)throw new Error("Your cart preference couldn't be saved.");return r.json()})
}
function read(){
 if(busy)return;
 return api("cart.js").then(function(cart){
  var a=cart.attributes||{};
  latestState=a["NDIS Invoice Requested"]==="Yes" && a["NDIS Funding Management"]==="Self-managed";
  setAll(latestState,"",false)
 }).catch(function(){ /* Leave server-rendered checkbox intact if the cart API is temporarily unavailable. */})
}
document.addEventListener("change",function(event){
 var target=event.target.closest("[data-ndis-cart-checkbox]");if(!target||busy)return;
 var requested=target.checked;
 var original=latestState===null?!requested:latestState;
 busy=true;setAll(requested,"Saving your invoice preference…",false);
 api("cart/update.js",{
  method:"POST",
  headers:{"Content-Type":"application/json","Accept":"application/json"},
  body:JSON.stringify({attributes:{
   "NDIS Invoice Requested":requested?"Yes":"",
   "NDIS Funding Management":requested?"Self-managed":""
  }})
 }).then(function(cart){
  var attrs=cart.attributes||{};
  if(requested && (attrs["NDIS Invoice Requested"]!=="Yes" || attrs["NDIS Funding Management"]!=="Self-managed"))throw new Error("Shopify couldn't confirm your invoice request.");
  latestState=requested;busy=false;
  setAll(latestState,requested?"Saved. Your order will be marked for an NDIS invoice request.":"Invoice request removed.",false)
 }).catch(function(){
  latestState=original;busy=false;
  setAll(original,"Your request couldn't be saved. Please try again before checkout.",true)
 })
});
document.addEventListener("click",function(event){
 if(!busy)return;
 var checkout=event.target.closest('button[name="checkout"],a[href*="/checkout"],.cart__checkout-button');
 if(checkout){
  event.preventDefault();event.stopImmediatePropagation();
  setAll(latestState,"Please wait while your NDIS invoice preference is saved.",true)
 }
},true);
document.addEventListener("submit",function(event){
 if(!busy)return;
 if(event.target.closest("form#cart-form") || event.submitter?.name==="checkout"){
  event.preventDefault();event.stopImmediatePropagation();
  setAll(latestState,"Please wait while your NDIS invoice preference is saved.",true)
 }
},true);
document.addEventListener("DOMContentLoaded",read);
document.addEventListener("shopify:section:load",read);
if(document.readyState!=="loading")read();
})();